/* eslint-disable */
/*------ React imports ------*/
import { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";

/*------ Helper imports ------*/
import * as url from "helper/UrlHelper";
import { getData } from "utils/Gateway";
import { assetImages } from "constants";
import { ecosystemSlug } from "Config/Config";
import EmptyDataView from "components/common/EmptyDataView/EmptyDataView";

const PostsTab = ({ tabName = "" }) => {
  const { id: companyId } = useParams(); // Renamed for clarity
  const token = localStorage.getItem("token");

  // State management
  const [isLoading, setIsLoading] = useState(true);
  const [blogList, setBlogList] = useState([]);
  const [isDataEmpty, setisDataEmpty] = useState(false);

  //function for get all blogs
  const getallBlogs = async () => {
    try {
      setIsLoading(true);
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_BLOGS +
        `?company=${companyId}`;

      const response = await getData(requestUrl);

      console.log(response);

      if (response.status) {
        if (response.data.length === 0) {
          setisDataEmpty(true);
        }

        setBlogList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (companyId && tabName === "posts") {
      getallBlogs();
    }
  }, [companyId, tabName]);

  if (isLoading) {
    return (
      <div className="post_item_outer">
        <div className="post_item">
          {/* You can map over a dummy array to show multiple placeholders */}
          {[...Array(5)].map((_, index) => (
            <div className="card shadow-sm mb-3" key={index} aria-hidden="true">
              <div className="card-body">
                <div className="placeholder-glow">
                  <div className="d-flex justify-content-between align-items-center">
                    {/* Left Side: Profile Image and Info */}
                    <div className="d-flex align-items-center">
                      {/* Placeholder for the circular profile image */}
                      <span
                        className="placeholder rounded-circle"
                        style={{ width: "80px", height: "50px" }}
                      ></span>

                      <div className="ms-3 w-100">
                        {/* Placeholder for Name (h3) */}
                        <h3 className="card-title mb-2">
                          <span
                            className="placeholder"
                            style={{ width: "100px" }}
                          ></span>
                        </h3>
                        {/* Placeholder for Role (h5) */}
                        <h5 className="card-subtitle">
                          <span
                            className="placeholder"
                            style={{ width: "100px" }}
                          ></span>
                        </h5>
                      </div>
                    </div>

                    {/* Right Side: Button */}
                    <div className="ms-3">
                      {/* Placeholder for the "View Details" button */}
                      <Link
                        to="#"
                        tabIndex="-1"
                        className="placeholder rounded-10"
                        style={{ width: "110px", height: "40px" }}
                      ></Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (isDataEmpty) {
    return (
      <div className="post_item_outer">
        <div className="post_item">
          <EmptyDataView moduleName="Posts" />
        </div>
      </div>
    );
  }

  return (
    <div className="post_item_outer">
      <div className="post_item">
        {blogList.map((blogData, index) => {
          return (
            <div className="white_shadow_bx people_bx" key={index}>
              <div className="people_row">
                <div className="left_people">
                  <div className="people_profile">
                    <img
                      width="64"
                      height="64"
                      className="rounded-circle"
                      src={
                        blogData.coverimage !== ""
                          ? url.SERVER_URL + blogData.coverimage
                          : assetImages.defaultUser
                      }
                      alt=""
                    />
                  </div>
                  <div className="people_profile_info">
                    <h3>{blogData.name}</h3>
                    <h5>{blogData.categorystring}</h5>
                  </div>
                </div>
                <div className="right_people_btn">
                  <Link
                    to={`/blogdetails/${blogData._id}`}
                    className="btn outline"
                  >
                    View Details
                  </Link>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PostsTab;
